import { ApplicationServices } from "../lib/ui/ApplicationServices.js";
import { FileRepositoryManager } from "./modules/core/managers/FileRepositoryManager.js";

export class TunnelDesignApplicationServices extends ApplicationServices {

    constructor(options = {}) {

        super(options);

        const {
            workspaceManager = null,
        } = options;

        this.workspaceManager = workspaceManager;

    }

    getWorkspaceManager() { return this.workspaceManager; }

    createFileRepositoryManager(options = {}) {

        return new FileRepositoryManager({
            httpClient: this.getHttpService(),
            config: this.getConfig(),
            ...options,
        });

    }

}
